<!-- @component Tracks page views and events, integrating with Segment and Posthog. -->

<script lang="ts">
  import { afterNavigate } from "$app/navigation";

  import { onMount } from "svelte";

  import {
    PUBLIC_POSTHOG_API_KEY,
    PUBLIC_SEGMENT_WRITE_KEY,
  } from "$env/static/public";
  import { analytics } from "$lib/analytics";
  import { user } from "$lib/user";

  // Segment and PostHog
  onMount(async () => {
    analytics.load({
      writeKey: PUBLIC_SEGMENT_WRITE_KEY,
    });
    // If user is logged in, associate all future events with the userId
    if ($user?.loggedIn) {
      const u = await analytics.user();
      u.id($user?.userId);
    }
    // Load Posthog asynchronously to avoid increasing bundle size.
    // We may update this if using Posthog feature flags.
    await Promise.all([
      import("posthog-js/dist/recorder" as any),
      // import("posthog-js/dist/surveys" as any),
      // import("posthog-js/dist/exception-autocapture" as any),
      // import("posthog-js/dist/tracing-headers" as any),
      import("posthog-js/dist/web-vitals" as any),
    ]);
    const posthog = (await import("posthog-js/dist/module.no-external"))
      .default;
    posthog.init(PUBLIC_POSTHOG_API_KEY, {
      api_host: "https://us.i.posthog.com",
      segment: analytics as any,
      person_profiles: "identified_only",
      capture_pageview: false,
      capture_pageleave: true,
    });
  });
  afterNavigate(() => {
    analytics.page({
      loggedIn: $user?.loggedIn ?? false,
    });
  });
</script>
